var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg003ChatHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6v5.69l2.78 2.78a.75.75 0 0 1 0 1.06.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1-.22-.53V6a.75.75 0 0 1 1.5 0zM12 2.25a9.64 9.64 0 0 0-6.5 2.5V3.33a.75.75 0 0 0-1.5 0v3.34a.75.75 0 0 0 .75.75h3.5a.75.75 0 0 0 0-1.5H6.44A8.16 8.16 0 0 1 12 3.75a8.25 8.25 0 0 1 0 16.5 8.16 8.16 0 0 1-5.83-2.42 7.8 7.8 0 0 1-.61-.68A.75.75 0 0 0 4.5 17a.76.76 0 0 0-.11 1.06 9 9 0 0 0 .72.8A9.63 9.63 0 0 0 12 21.75a9.75 9.75 0 0 0 0-19.5zm-9 9.1h.12a.76.76 0 0 0 .74-.64 7.88 7.88 0 0 1 .44-1.65.75.75 0 0 0-1.41-.53 9.49 9.49 0 0 0-.51 2 .75.75 0 0 0 .62.82zm1.3 3.58a7.88 7.88 0 0 1-.44-1.65.76.76 0 0 0-.86-.63.75.75 0 0 0-.62.86 10 10 0 0 0 .51 2 .77.77 0 0 0 .71.49.85.85 0 0 0 .26 0 .76.76 0 0 0 .43-1.07z",
    fill: "#a59887",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003ChatHistory);
export default __webpack_public_path__ + "static/media/003-chat-history.3331ba9ff99867c5c0013f6cf922fcfc.svg";
export { ForwardRef as ReactComponent };